import React, { Component } from 'react';

class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (error.name === 'ChunkLoadError') {
      return { hasError: true };
    }
    throw error;
  }

  static handleReload() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '200px',
            gap: '16px',
            padding: '24px',
            textAlign: 'center',
          }}
        >
          <p style={{ fontSize: '16px', color: '#667085' }}>
            A new version is available. Please reload to continue.
          </p>
          <button
            type="button"
            onClick={ChunkErrorBoundary.handleReload}
            style={{
              padding: '8px 24px',
              fontSize: '14px',
              borderRadius: '6px',
              border: '1px solid #d0d5dd',
              background: '#fff',
              cursor: 'pointer',
              color: '#344054',
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
